import { Box, Fade, Paper, Popper } from "@mui/material";
import React, { useEffect } from "react";
import { arrowBottom } from "../../assets/svgs";
import { rowVerticalCenter } from "../../GlobalStyles";
import CustomIconButton from "../../Components/CustomIconButton";

function HoverCard({
  content,
  icon,
  mt,
}: {
  content: React.ReactNode;
  icon?: React.ReactNode;
  mt?: number | string;
}) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [open, setOpen] = React.useState(false);
  const [placement, setPlacement] = React.useState<
    "bottom-end" | "top-end" | undefined
  >("bottom-end");

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    // Add slight delay to prevent flicker when moving between icon and popper
    setTimeout(() => {
      setOpen(false);
    }, 150);
  };

  // Optional: Close on outside click (safety fallback)
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        anchorEl &&
        !anchorEl.contains(event.target as Node) &&
        !(event.target as HTMLElement).closest(".hover-popper-content")
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [anchorEl]);

  return (
    <Box
    onClick={(e)=>{e.stopPropagation()}}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "help",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Popper
        className="hover-popper-content"
        open={open}
        anchorEl={anchorEl}
        placement={placement}
        transition
        modifiers={[
          {
            name: "flip",
            enabled: true,
            options: {
              altBoundary: true,
              rootBoundary: "viewport",
              padding: 8,
            },
          },
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              altAxis: true,
              tether: true,
              rootBoundary: "viewport",
              padding: 8,
            },
          },
        ]}
        sx={{
          zIndex: 999999,
          mt: mt ?? 1,
          maxWidth: "calc(100vw - 16px)",
          maxHeight: "calc(100vh - 16px)",
          overflow: "auto",
          pointerEvents: "none", // ensures hover smoothness
        }}
        disablePortal
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={150}>
            <Paper
              sx={{
                p: 1.5,
                maxHeight: "80vh",
                overflowY: "auto",
                boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                borderRadius: 0,
                pointerEvents: "auto", // re-enable mouse inside content
              }}
              onMouseEnter={() => setOpen(true)} // keep open while hovering over popper
              onMouseLeave={handleMouseLeave}
            >
              {content ?? ""}
            </Paper>
          </Fade>
        )}
      </Popper>

      <CustomIconButton
        content={icon ?? arrowBottom}
        noHover
        sx={{ height: "100%", ...rowVerticalCenter }}
      />
    </Box>
  );
}

export default HoverCard;
